// ------------------------------------
// Constants
// ------------------------------------
export const SET_ITEMS = 'SET_PACKAGING_TYPES'

// ------------------------------------
// Actions
// ------------------------------------
export const setItems = ({ items }) => ({
    type: SET_ITEMS,
    items
});

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
    items: []
};

const packagingTypes = (state = initialState, action) => {
    switch (action.type) {
        case SET_ITEMS:
            return {
                ...state,
                items: action.items,
            }
        default:
            return state
    }
}

export default packagingTypes;


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/modules/packagingTypes.js